import _ from 'underscore';

export const getRegion = (i18n) => {
  let region = '';
  if (!_.isEmpty(i18n) && _.isFunction(i18n.getCldr)) {
    const cldr = i18n.getCldr();
    region = _.get(cldr, ['attributes', 'region']) || '';
  }
  return region;
};
